var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.3567,
    y: 14.0001,
    width: 1.71431,
    height: 12.0002,
    rx: 0.857157,
    transform: "rotate(-180 13.3567 14.0001)",
    fill: "#212B36"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.63869 1.99939C4.89806 1.9985 5.14388 2.11511 5.30728 2.31653L9.44734 7.45947C9.70733 7.77577 9.70733 8.23177 9.44734 8.54806L5.16156 13.691C4.85859 14.0555 4.31748 14.1054 3.95297 13.8024C3.58845 13.4995 3.53856 12.9584 3.84154 12.5938L7.67303 7.99948L3.97011 3.40512C3.75609 3.14821 3.711 2.7903 3.85461 2.48833C3.99823 2.18636 4.30434 1.99548 4.63869 1.99939Z",
    fill: "#212B36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightEnd);
export default __webpack_public_path__ + "static/media/arrow-right-end.4fed65b07e32b6617e3727c4de2d5583.svg";
export { ForwardRef as ReactComponent };